var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nuxt',{attrs:{"keep-alive":_vm.keepAlive,"keepAliveProps":_vm.keepAliveProps}}),_vm._v(" "),_c('ViewToken'),_vm._v(" "),_c('ViewVersion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }